export default function Certification() {
  return (
    <section className="py-20 bg-gradient-to-br from-primary-500 to-primary-700 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-6">
              Formación Adaptada al INCUAL
            </h2>
            <p className="text-xl text-blue-50 mb-8 leading-relaxed">
              Nuestra formación está adaptada al Instituto Nacional de las Cualificaciones (INCUAL) según los Reales Decretos 545/2023 y 917/2024. Programa completo de adiestramiento de base y educación canina, nivel 2 (SEA531_2), que incluye los estándares de competencia ECP1741_2, ECP1742_2, ECP1743_2 y ECP1744_2. Todo enmarcado en el Real Decreto 69/2025 que desarrolla el Sistema Nacional de Formación Profesional.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-fill text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Adaptada al INCUAL</h3>
                  <p className="text-blue-50">
                    Formación diseñada según los estándares del Instituto Nacional de las Cualificaciones, siguiendo el RD 69/2025 que regula el Catálogo Nacional de Estándares de Competencias Profesionales (CNECP).
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-list-3-fill text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">RD 545/2023 y RD 917/2024</h3>
                  <p className="text-blue-50">
                    Certificados de profesionalidad oficiales del Ministerio de Educación, Formación Profesional y Deportes de España.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-medal-fill text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Nivel de Cualificación 2</h3>
                  <p className="text-blue-50">
                    <strong>ECP1741_2:</strong> Adiestrar al perro con técnicas de adiestramiento de base (RD 545/2023)<br/>
                    <strong>ECP1742_2:</strong> Intervenir en el comportamiento canino (RD 917/2024)<br/>
                    <strong>ECP1743_2:</strong> Realizar labores de cuidados e higiene canina (RD 917/2024)<br/>
                    <strong>ECP1744_2:</strong> Realizar labores de primeros auxilios aplicados a perros (RD 917/2024)
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-global-fill text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Reconocimiento Europeo</h3>
                  <p className="text-blue-50">
                    Certificación válida en toda la Unión Europea según el Marco Europeo de Cualificaciones.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-briefcase-fill text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Salidas Profesionales</h3>
                  <p className="text-blue-50">
                    Trabaja como adiestrador profesional, educador canino, técnico en modificación de conductas, especialista en cuidados e higiene, o inicia tu propio negocio.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-text-fill text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">Documentación Oficial BOE</h3>
                  <div className="space-y-2">
                    <a
                      href="https://www.boe.es/diario_boe/txt.php?id=BOE-A-2025-2039"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-blue-50 hover:text-white transition-colors cursor-pointer underline"
                    >
                      → Ver RD 69/2025 - Normativa CNECP
                    </a>
                    <a
                      href="https://www.boe.es/diario_boe/txt.php?id=BOE-A-2023-13800"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-blue-50 hover:text-white transition-colors cursor-pointer underline"
                    >
                      → Ver RD 545/2023 en BOE
                    </a>
                    <a
                      href="https://www.boe.es/diario_boe/txt.php?id=BOE-A-2024-18537"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block text-blue-50 hover:text-white transition-colors cursor-pointer underline"
                    >
                      → Ver RD 917/2024 en BOE
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white rounded-2xl p-8 shadow-2xl">
              <div className="text-center mb-6">
                <div className="w-24 h-24 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-fill text-secondary-600 text-5xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Formación Adaptada al INCUAL
                </h3>
                <p className="text-gray-600">
                  Certificados de Profesionalidad Canina
                </p>
              </div>

              <div className="border-t border-gray-200 pt-6 space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-600 font-medium">Nivel:</span>
                  <span className="text-gray-900 font-bold">Cualificación 2</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600 font-medium">Códigos ECP:</span>
                  <span className="text-gray-900 font-bold text-sm">1741_2,1742:2, 1743_2 y 1744_2</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600 font-medium">Normativas:</span>
                  <span className="text-gray-900 font-bold text-sm">RD 545/2023 y 917/2024</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600 font-medium">Duración Total:</span>
                  <span className="text-gray-900 font-bold">360 horas</span>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200">
                <h4 className="font-bold text-gray-900 mb-3">Incluye:</h4>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2 text-gray-700">
                    <i className="ri-check-line text-secondary-600 font-bold"></i>
                    <span className="text-sm">Conocimientos de riesgos laborales</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-700">
                    <i className="ri-check-line text-secondary-600 font-bold"></i>
                    <span className="text-sm">Bienestar animal</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-700">
                    <i className="ri-check-line text-secondary-600 font-bold"></i>
                    <span className="text-sm">Prácticas profesionales</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-700">
                    <i className="ri-check-line text-secondary-600 font-bold"></i>
                    <span className="text-sm">Evaluación continua</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-700">
                    <i className="ri-check-line text-secondary-600 font-bold"></i>
                    <span className="text-sm">Documentación oficial BOE</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
